module.exports = __webpack_public_path__ + "img/image4.ddc12fe4.png";